import React from "react";
import Slider from "react-slick";
import CaseStudyCard from "./caseStudyCard";
import { useMediaQuery } from "react-responsive";

const CaseStudies = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 992px)" });

  const PrevArrow = props => {
    const { className, onClick } = props;
    return <button onClick={onClick} className={className} />;
  };

  const NextArrow = props => {
    const { className, onClick } = props;
    return <button onClick={onClick} className={className} />;
  };

  const settings = {
    arrows: isTablet ? false : true,
    infinite: true,
    speed: 800,
    autoplaySpeed: 5000,
    autoplay: true,
    dots: false,
    draggable: isTablet ? true : false,
    slidesToShow: isMobile ? 1.2 : isTablet ? 2 : 2,
    slidesToScroll: isMobile ? 1 : 2,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <div id="caseStudies">
      <Slider {...settings}>
        {content.caseCards.map((card, i) => (
          <CaseStudyCard key={i} content={card} />
        ))}
      </Slider>
    </div>
  );
};

export default CaseStudies;
